import { axios } from '@Root/API'

export const postContinuingStudents = payload => {
  return axios.post(`students/rollover-continuing`, payload)
}
